var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AllRecordsTable',{attrs:{"submit-button-text":"Добавить пользователя","table-name":"users","link-slug":"users","title":"Пользователи","foreign-key-values":_vm.usersTable.foreignKeyValues,"filter-fields":_vm.usersTable.filterFields,"columns":_vm.usersTable.columnNames,"order-fields":_vm.usersTable.orderFields,"rows":_vm.usersTable.rowNames}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d012084","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/user/pages/AllUsersPage.vue
// module id = null
// module chunks = 